import { Box } from '@factorialco/deprecated-design-system'
import { F0Heading } from '@factorialco/f0-react'
import { PostBreadcrumbDocument } from 'generated/resources/graphql'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useParams } from 'react-router-dom'

const PostInsightsPage = () => {
  const id = useParams().id ?? ''
  const { data, loading, error } = useQuery(PostBreadcrumbDocument, { variables: { id } })
  const title = data?.posts.post?.title ?? ''

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      <Box flexGrow>
        <F0Heading
          content={title}
          variant="heading"
          aria-label={i18n.t('posts.communities.insights.post_title_label')}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default PostInsightsPage
